import React from 'react';

import { cn, css } from '@lyearn/style';
import { Avatar, Box } from '@lyearn/ui';

import { InsightsRecommendationItem } from '../types';
import { getRecommendationIcon } from '../utils';

const avatarBorderEffect = css`
  box-shadow: 0 0 0 8px #cccccc4d;
`;

interface Props {
  recommendation: InsightsRecommendationItem;
}

function InsightRowIcon(props: Props) {
  const { recommendation } = props;

  const avatarUrl = recommendation.card?.avatar?.url;
  const Icon = getRecommendationIcon(recommendation);

  if (avatarUrl) {
    return (
      <Box className="relative w-48 h-48">
        <Avatar
          alt={recommendation.card?.title}
          classes={{ border: avatarBorderEffect }}
          size={48}
          src={avatarUrl}
        />
        <Box className="absolute bottom-[-0.5rem] right-[-1.1rem] w-32 h-32 bg-white rounded-full shadow-01 grid place-items-center">
          <Icon className="w-16 h-16" fillColorToken="icon-primary" />
        </Box>
      </Box>
    );
  }

  if (Icon) {
    return (
      <Box
        className={cn(
          'w-48 h-48 p-6 rounded-full grid place-items-center bg-[#FAF7F0]',
          // getIconBorderColor(recommendation.targetModule),
        )}>
        <Icon className="w-20 h-20" fillColorToken="icon-secondary" />
      </Box>
    );
  }

  return <Box className="w-48 h-48" />;
}

export default React.memo(InsightRowIcon);
